import React from "react";

const Arhar = () => {
  return (
    <div className="container my-3">
      <div className="abouts">
        <h5>Arhar</h5>
      </div>

      <div
        className="about-box p-4 rounded shadow-lg table-responsive"
        style={{ textAlign: "justify" }}
      >
        <table className="table table-striped table-bordered">
          <thead className="text-center">
            <tr>
              <th>Seed Rate</th>
              <th>Sowing Time</th>
              <th>Irrigation</th>
              <th>Maturity Time</th>
              <th>Characterstics</th>
              <th>Average Yield</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colspan="6">
                <strong>MANAK [Released in 11.11.1985]</strong>
              </td>
            </tr>
            <tr>
              <td>4-6 kgs per acre.</td>
              <td>June to mid July.</td>
              <td>
                1-2 irrigations. One irrigation at flowering stage is must.
              </td>
              <td>125-130 days.</td>
              <td>Plant of this variety is of medium height.</td>
              <td>7-8 quintals per acre.</td>
            </tr>
            <tr>
              <td colspan="6">
                <strong>PARAS (H62 - 1) [Released in 15.05.1998]</strong>
              </td>
            </tr>
            <tr>
              <td>4-6 kgs per acre when sown timely and 6-8 when sown late.</td>
              <td>Timely sowing variety, i.e. in the month of June.</td>
              <td>1-2 irrigations.</td>
              <td>140-145 days.</td>
              <td>
                Plant of this variety has more branches and pods and bold grain
                as compared to Manak and UP AS - 120 varieties. This variety is
                disease-free in Haryana. Drought resistant. Suitable for
                irrigated areas of Haryana.
              </td>
              <td>7-8 quintals per acre.</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Arhar;
